export default function createLoadBalancerReducer
    (state = { error:'', success:'', processing:false}, action)
{
    switch (action.type) {
        case 'CREATE_LOAD_BALANCER_SUCCESS':
            return {...state, ...{success: action.success}};

        case 'CREATE_LOAD_BALANCER_ERROR':
            return {...state, ...{error: action.error}};

        case 'CREATE_LOAD_BALANCER_PROCESSING':
            return {...state, ...{processing: action.processing}};

        default: return state;
    }
}